import { Component,Input, Output, EventEmitter } from '@angular/core';

@Component({
  moduleId: module.id,
  selector: 'org-form',
  templateUrl: 'org.form.component.html'
})

export class OrgFormComponent {
  @Output() onSubmit: EventEmitter<any> = new EventEmitter<any>();
  @Input() model: any = {};
  @Input() loading: boolean;

  constructor(){}

  submit() {
    this.onSubmit.emit(this.model);
  }

}



// WEBPACK FOOTER //
// ./src/app/orgs/org.form.component.ts